<template>
  <div
    class="group__info margin-top-10 margin-bottom-10 padding-bottom-10"
    v-if="relationDocs.length"
  >
    <div class="title font-size__medium">{{ title }}</div>
    <div class="ctn">
      <template>
        <el-table
          class="table detailRelatedDocs"
          :data="relationDocs"
          style="max-width: 100%; width: 100%"
          size="mini"
        >
          <el-table-column label="Trích yếu" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="docName flex-row flex__left margin-right-10">
                <file-type-image
                  :custom-class="''"
                  :file-extention="scope.row.fileExtention"
                >
                </file-type-image>
                <a
                  class="
                    txt
                    style-fullWidth
                    margin-left-10
                    color__black
                    clickable
                  "
                  @click="downloadFile(scope.row)"
                >
                  {{ scope.row.quote || "-" }}
                </a>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Loại văn bản"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-select
                class="style-fullWidth inputBg__white"
                v-model="scope.row.relationType"
                size="mini"
                filterable
                clearable
                placeholder="-"
              >
                <el-option
                  v-for="item in docRelationTypes"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="Số ký hiệu" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.docCode || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            label="Ngày văn bản"
            width="135"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.docDate
                  | dateFormatter({ dateFormat: "DD/MM/YYYY", nullValue: "-" })
              }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="checkAddDocRelation"
            align="center"
            header-align="left"
            width="40"
          >
            <template slot-scope="scope">
              <i
                class="
                  el-icon-circle-close
                  font-size__large
                  color__red
                  clickable
                "
                @click="removeRelationDoc(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-if="checkAddDocRelation"
          class="flex-row flex__left margin-top-10 margin-bottom-10"
        >
          <el-upload
            multiple
            :limit="10"
            :on-exceed="handleExceed"
            :accept="DOCUMENT_FILE.ACCEPT_TYPES"
            :action="uploadAttachmentURL"
            :on-success="onUploadSuccess"
            :data="uploadRelationDocAdditionalData"
            :show-file-list="false"
            :headers="uploadAttachmentHeaders"
            :before-upload="(file) => validateUploadFile(file)"
            :on-error="onUploadError"
            :on-change="() => (isUploadingRelationDocFlag = true)"
            v-loading="isUploadingRelationDocFlag && isUploading"
          >
            <el-button class="btnPlain margin-right-10">
              <i class="fas fa-cloud-upload-alt"></i>
              &nbsp;Tải file lên
            </el-button>
          </el-upload>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import docRelationService from "../../services/docRelationService";
import h from "../../services/h";
import constants from "../../constants";
import vbAttachmentTokenService from "../../services/vbAttachmentTokenService";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import dateFormatter from "../../filters/dateFormatter";
import convertToLabelFilter from "../../filters/convertToLabelFilter";
import FileTypeImage from "../common/FileTypeImage";
import categoryViewService from "../../services/categoryViewService";
import downloadService from "../../services/downloadService";
import uploadFileMixin from "../doc-in/uploadFileMixin";
import handleRequestErrorMixin from "../handleRequestErrorMixin";

export default {
  name: "doc-relations-detail",
  props: ["docId", "title", "checkAddDocRelation"],
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  filters: { dateFormatter, buildAttachmentURL, convertToLabelFilter },
  components: {
    FileTypeImage,
  },

  data() {
    return {
      DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      relationDocs: [],
      docRelationTypes: [],
      DOCUMENT_FILE: constants.DOCUMENT_FILE,
      uploadRelationDocAdditionalData: {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.RELATION_DOC,
      },
      isUploadingRelationDocFlag: null,
    };
  },

  computed: {
    userVbOutgoingProcessId() {
      return this.$route.query.vbDocProcessId;
    },
  },

  created() {
    this.loadCategories();
    this.loadRelationDocs();
  },

  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(
        `Chọn tối đa 10 files một lần, bạn đã chọn ${files.length} files!`
      );
    },
    loadRelationDocs() {
      this.relationDocs = [];
      if (!this.docId) return;
      return docRelationService
        .findAll({
          objectId: this.docId,
          attachedType: constants.DOC_RELATION_ATTACHED_TYPE.SCAN,
        })
        .then((response) => {
          h.each(response.data, (item) => {
            this.relationDocs.push({
              id: item.id,
              objectRelateToId: item.objectRelateToId,
              docCode: item.docCode,
              quote: item.quote,
              docDate: item.docDate,
              objectTypeRelateTo: item.objectTypeRelateTo,
              relationType: item.relationType,
            });
          });
        });
    },

    getRelationDocs() {
      return this.relationDocs;
    },

    getRelationTypeLabel(relationType) {
      let docRelationType = h.find(
        this.docRelationTypes,
        (docRelationType) => docRelationType.id === relationType
      );
      return docRelationType ? docRelationType.categoryName : null;
    },

    removeRelationDoc(relationDoc) {
      this.relationDocs.splice(this.relationDocs.indexOf(relationDoc), 1);
      this.updateDocIds();
    },

    updateDocIds() {
      this.docIds = h.collect(
        h.findAll(
          this.relationDocs,
          (item) =>
            item.objectTypeRelateTo ===
            constants.DOC_RELATION_OBJECT_TYPE.VB_DEN
        ),
        (item) => item.objectRelateToId
      );
    },

    onUploadSuccess(vbAttachment) {
      this.isUploading = false;
      this.relationDocs.push({
        objectRelateToId: vbAttachment.id,
        quote: vbAttachment.fileName,
        docDate: vbAttachment.updateTime,
        objectTypeRelateTo: constants.DOC_RELATION_OBJECT_TYPE.ATTACHMENT,
        relationType: this.defaultRelationType,
      });
    },

    loadCategories() {
      return categoryViewService
        .findAll(
          { groupCode: constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE },
          { sort: "order,asc" }
        )
        .then((response) => {
          this.docRelationTypes = response.data.filter(
            (item) => item.status !== "deactive"
          );
          let canCuCategory = h.find(this.docRelationTypes, (relationType) =>
            this.checkAddDocRelation
              ? relationType.categoryCode === "vbscan" ||
                relationType.categoryName.toUpperCase() === "VB Scan"
              : relationType.categoryCode === "cancu" ||
                relationType.categoryName.toUpperCase() === "CĂN CỨ"
          );
          this.defaultRelationType = canCuCategory ? canCuCategory.id : null;
        });
    },

    downloadFile(docRelation) {
      switch (docRelation.objectTypeRelateTo) {
        case constants.DOC_RELATION_OBJECT_TYPE.ATTACHMENT:
          downloadService.downloadFileCommon(
            vbAttachmentTokenService
              .getToken(docRelation.objectRelateToId)
              .then((response) => response.data),
            constants.DOWNLOAD_FILE_URL.DEFAULT_URL
          );
          break;
        case constants.DOC_RELATION_OBJECT_TYPE.OUTGOING_DOC:
        case constants.DOC_RELATION_OBJECT_TYPE.VB_DEN:
          downloadService.downloadFileCommon(
            vbAttachmentTokenService
              .getTokenDocRelation(docRelation.id)
              .then((response) => response.data),
            buildAttachmentURL({ type: constants.DOWNLOAD_OPTION.TYPE.PDF })
          );
          break;
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/doc-relations-detail.vue